export default __webpack_public_path__ + "static/media/rec.cd243ee6.jpg";